<template>
  <vxe-table
    border
    stripe
    round
    show-overflow
    show-header-overflow
    :export-config="{}"
    :keyboard-config="{isArrow: true}"
    align="center"
    ref="table"
    :data="data"
    :loading="loading"
    size="mini"
    :height="scrollY"
    :scroll-x="{enabled: true}"
    :row-config="{isCurrent: true, isHover: true}"
    :column-config="{resizable: true}">
    <vxe-column fixed="left" type="seq" width="40"/>
    <vxe-column field="dispatch.wave" title="business.label.wave" width="100"/>
    <vxe-column field="ordersCount" title="business.label.ordersCount" />
  </vxe-table>
</template>

<script>
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'UnstagedTable',
    data() {
      return {
        data: [],
        loading: false,
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.845)// 表格竖向滚动条
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      getData() {
        this.loading = true
        findAll('dispatchWaveUnstagedFactory').then((res) => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
          }
          this.loading = false
        })
      },
      stage() {
        let selectedRow = this.$refs.table.getCurrentRecord()
        if (selectedRow == null) {
          this.$warning({ title: '请选择波次后再集货', centered: true })
        }
        this.loading = true
        post(Api.containerStageAll, {}, { 'wave': selectedRow.dispatch.wave }).then(res => {
          if (res.success) {
            this.$message.success('集货成功')
            this.getData()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>
